import React from 'react';
import css from './SvgIcon.module.css';
import PropTypes from "prop-types";
export default function SvgIcon(props) {
  var _props$size, _props$size2, _props$size3, _props$color;
  return /*#__PURE__*/React.createElement("i", {
    className: [css['svg-icon'], css[props.icon]].join(' '),
    style: {
      width: "".concat((_props$size = props.size) === null || _props$size === void 0 ? void 0 : _props$size.toString().concat('px')),
      height: "".concat((_props$size2 = props.size) === null || _props$size2 === void 0 ? void 0 : _props$size2.toString().concat('px')),
      backgroundRepeat: "no-repeat",
      backgroundSize: "".concat((_props$size3 = props.size) !== null && _props$size3 !== void 0 ? _props$size3 : 16, "px"),
      color: "".concat((_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#000')
    }
  });
}
SvgIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string
};